import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { object, func, array, bool } from 'prop-types';
import { startSetStreamSettings, resetStream } from '../../../actions/streams';
import { scrollToError } from './../formErrorHelper';
import api from '../../../services/ApiService';
import { FMessage, iFMessage } from '../../../hoc/IntlComponents';

import { StreamTDSFormView } from '../index';

const defaultScriptOption = { t: '', s: '' };
const defaultScriptOptionMulti = { t: '', s: [] };
const defaultScript = {
  r: '',
  s: [defaultScriptOption],
  t: '',
};

const keysInScripts = [
  'scriptsTitlesErrors',
  'defaultStreamsErrors',
  'scriptsOptionsTypeErrors',
  'scriptsOptionsValueErrors',
];

const errorKeys = ['titleError', 'flowError', ...keysInScripts];

const getUniqIds = (list, key) => _.compact(_.uniq(_.map(list, f => f[key])));

class StreamTDSForm extends Component {
  static propTypes = {
    onSubmit: func.isRequired,
    streamTDS: object,
    loading: bool,
    intl: intlShape.isRequired,
    settingsTDS: object.isRequired,
    defaultStreams: array.isRequired,
  };
  static defaultProps = {
    loading: true,
    settingsTDS: {},
    defaultStreams: [],
  };
  constructor(props) {
    super(props);

    let title = props.streamTDS ? props.streamTDS.title : '';

    this.state = {
      streamTDS: {
        editable: true,
        id: props.streamTDS ? props.streamTDS.id : undefined,
        title,
        flow: props.streamTDS ? props.streamTDS.flow : '',
      },
      scripts: props.streamTDS ? props.streamTDS.scripts : [defaultScript],
      subAccount: '',
      errors: {},
      flowsInfo: [],
      offersInfo: [],
      notFoundOffersInStreams: {},
    };
    this._alertRefs = {
      titleError: createRef(),
      flowError: createRef(),
    };
  }
  getFlowsInfo = (id, cbLoading, cbLoad) => {
    const { flowsInfo } = this.state;
    const flowsIds = flowsInfo.length && getUniqIds(flowsInfo, 'id');
    if ((id && !flowsIds) || (id && !_.includes(flowsIds, id))) {
      this.getInfo(id, 'streams', 'getStream', 'flowsInfo', cbLoading, cbLoad);
    } else {
      if (cbLoading && cbLoad) {
        cbLoading();
        cbLoad();
      }
    }
  };
  getNewOffersIds = (offersIds, prevOffersIds) => {
    let res = false;
    _.each(offersIds, id => {
      if (!_.includes(prevOffersIds, id)) {
        res = id;
      }
    });
    return res;
  };

  getInfo = (id, apiPath, apiMethod, statePath, cbLoading, cbLoad) => {
    if (cbLoading) {
      cbLoading();
    }
    api[apiPath][apiMethod](id)
      .then(data => {
        this.setState(prevState => ({
          ...prevState,
          [statePath]: [...prevState[statePath], data.items[0]],
        }));
      })
      .catch(({ response }) => {
        if (response && response.data) {
          const { message: error } = response.data.error;
          if (error.type === 'api.offers.not_found') {
            this.setState(prevState => ({
              ...prevState,
              notFoundOffersInStreams: {
                ...prevState.notFoundOffersInStreams,
                [id]: true,
              },
            }));
          }
        }
      })
      .finally(() => {
        if (cbLoad) {
          cbLoad();
        }
      });
  };
  getOffersInfo = (id, cbLoading, cbLoad) => {
    this.getInfo(id, 'offers', 'getOfferInfo', 'offersInfo', cbLoading, cbLoad);
  };
  componentDidUpdate(prevProps, prevState) {
    const { flowsInfo } = this.state;
    if (flowsInfo.length !== prevState.flowsInfo.length) {
      const offersIds = getUniqIds(flowsInfo, 'offerId');
      const prevOffersIds = getUniqIds(prevState.flowsInfo, 'offerId');
      const newOfferId = this.getNewOffersIds(offersIds, prevOffersIds);
      if (newOfferId) {
        this.getInfo(newOfferId, 'offers', 'getOfferInfo', 'offersInfo');
      }
    }
  }
  needScrollToMainScript = (errors, key) => {
    const optIndex = _.findIndex(errors[errorKeys[key]], err => err);
    return [errorKeys[key], `[${optIndex}]`];
  };
  needScrollToScriptOption = (errors, key) => {
    const optIndex = _.findIndex(errors[errorKeys[key]], el => _.isArray(el));
    const optKey = _.findIndex(errors[errorKeys[key]][optIndex], err => err);
    return [errorKeys[key], `[${optIndex}]`, `[${optKey}]`];
  };
  needScrollToOneOfSelectors = errors => {
    const typeKey = this.needScrollToScriptOption(errors, 4);
    const valueKey = this.needScrollToScriptOption(errors, 5);
    if (typeKey[1] > valueKey[1]) {
      return valueKey;
    } else if (typeKey[1] < valueKey[1]) {
      return typeKey;
    } else {
      if (typeKey[2] > valueKey[2]) {
        return valueKey;
      } else if (typeKey[2] < valueKey[2]) {
        return typeKey;
      }
      return typeKey;
    }
  };
  needScroll = (errorPaths, errors) => {
    const isTitleError = _.includes(errorPaths, errorKeys[0]);
    const isFlowError = _.includes(errorPaths, errorKeys[1]);
    if (isTitleError) {
      return [errorKeys[0]];
    } else if (isFlowError) {
      return [errorKeys[1]];
    } else {
      const isScriptTitleError = _.includes(errorPaths, errorKeys[2]);
      const isDefaultStreamsErrors = _.includes(errorPaths, errorKeys[3]);
      const isScriptsOptionsTypeErrors = _.includes(errorPaths, errorKeys[4]);
      const isScriptsOptionsValueErrors = _.includes(errorPaths, errorKeys[5]);
      if (isScriptTitleError) {
        return this.needScrollToMainScript(errors, 2);
      } else if (isDefaultStreamsErrors) {
        return this.needScrollToMainScript(errors, 3);
      } else if (isScriptsOptionsTypeErrors && !isScriptsOptionsValueErrors) {
        return this.needScrollToScriptOption(errors, 4);
      } else if (isScriptsOptionsValueErrors && !isScriptsOptionsTypeErrors) {
        return this.needScrollToScriptOption(errors, 5);
      } else if (isScriptsOptionsTypeErrors && isScriptsOptionsValueErrors) {
        return this.needScrollToOneOfSelectors(errors);
      }
      return [];
    }
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { streamTDS = {}, defaultStreams } = nextProps;
    if (streamTDS && streamTDS.id !== this.state.streamTDS.id) {
      const { scripts, ...rest } = streamTDS;
      const collectAllFlowIds = _.uniq([rest.id, ...scripts.map(script => +script.r)]);
      collectAllFlowIds.forEach(id => {
        const findedFlow = defaultStreams.find(stream => stream.id === id);
        if (!findedFlow && id !== streamTDS.id) {
          this.getInfo(id, 'streams', 'getStream', 'flowsInfo');
        }
      });
      this.setState(() => ({
        streamTDS: rest,
        scripts,
      }));
    }
  }

  componentWillUnmount() {
    this.props.resetStream();
  }
  componentDidMount() {
    this.props.startSetStreamSettings().then(() => {
      const { streamTDS } = this.state;
      const { settings, intl } = this.props;
      if (
        streamTDS &&
        !streamTDS.id &&
        !streamTDS.title &&
        settings.base &&
        settings.base.nextFlowIndex >= 0
      ) {
        this.setState(({ streamTDS }) => ({
          streamTDS: {
            ...streamTDS,
            title: `${iFMessage({
              intl,
              id: 'flow.form.title.placeholder',
            })} ${settings.base.nextFlowIndex}`,
          },
        }));
      }
    });
  }
  handleChange = ({ target }) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      if (target.name === 'title' && !prevState.streamTDS.title) {
        if (target.value) {
          const hasError = prevState.errors[errorKeys[0]];
          if (hasError) {
            delete errors[errorKeys[0]];
          }
        }
      }
      return {
        streamTDS: {
          ...prevState.streamTDS,
          [target.name]: target.value,
        },
        errors,
      };
    });
  };
  onSelectChange = (prop, value) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      if (prop === 'flow' && !prevState.streamTDS[prop]) {
        if (value) {
          const hasError = prevState.errors[errorKeys[1]];
          if (hasError) {
            delete errors[errorKeys[1]];
          }
        }
      }
      return {
        ...prevState,
        streamTDS: {
          ...prevState.streamTDS,
          [prop]: value,
        },
        errors,
      };
    });
  };
  handleScriptTitleChange = (target, key) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = _.cloneDeep(prevState.scripts);
      if (target.name === 'title' && !prevState.scripts[key].t) {
        if (target.value) {
          const hasError = prevState.errors[errorKeys[2]] && prevState.errors[errorKeys[2]][key];
          if (hasError) {
            delete errors[errorKeys[2]][key];
          }
        }
      }
      scripts[key].t = target.value;
      return {
        scripts,
        errors,
      };
    });
  };
  onSelectScriptDefaultStreamChange = (prop, value) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = _.cloneDeep(prevState.scripts);
      if (!prevState.scripts[prop].r) {
        if (value) {
          const hasError = prevState.errors[errorKeys[3]] && prevState.errors[errorKeys[3]][prop];
          if (hasError) {
            delete errors[errorKeys[3]][prop];
          }
        }
      }
      scripts[prop] = {
        ...scripts[prop],
        r: value.toString(),
      };
      return {
        scripts,
        errors,
      };
    });
  };
  saveRef = (inScripts, errorPath, ref, key, optKey) => {
    if (!_.get(this._alertRefs, `${errorPath}`)) {
      this._alertRefs[errorPath] = [];
    }
    if (optKey !== undefined) {
      if (!_.get(this._alertRefs, `${errorPath}[${key}]`)) {
        this._alertRefs[errorPath][key] = [];
      }
      if (!_.get(this._alertRefs, `${errorPath}[${key}][${optKey}]`)) {
        this._alertRefs[errorPath][key][optKey] = [];
      }
    }
    if (!inScripts) {
      this._alertRefs = { ...this._alertRefs, [errorPath]: ref };
    } else {
      if (optKey === undefined) {
        this._alertRefs[errorPath][key] = ref;
      } else {
        this._alertRefs[errorPath][key][optKey] = ref;
      }
    }
  };
  onRemoveScript = key => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = prevState.scripts.filter((s, i) => i !== key);
      keysInScripts.forEach(errorKey => {
        if (errors[errorKey]) {
          errors[errorKey].splice(key, 1);
        }
      });
      return {
        scripts,
        errors,
      };
    });
  };
  onAddScript = () => {
    this.setState(prevState => {
      const scripts = _.cloneDeep(prevState.scripts);
      scripts.push(defaultScript);
      return { scripts };
    });
  };
  onSelectScriptOptionType = (scrKey, optId, value) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = _.cloneDeep(prevState.scripts);
      if (!_.get(scripts, `[${scrKey}].s[${optId}].t}`)) {
        if (value) {
          const hasError =
            prevState.errors[errorKeys[4]] &&
            prevState.errors[errorKeys[4]][scrKey] &&
            prevState.errors[errorKeys[4]][scrKey][optId];
          if (hasError) {
            delete errors[errorKeys[4]][scrKey][optId];
          }
        }
      }
      const defOpt =
        value === 'GCN' || value === 'GC' ? defaultScriptOptionMulti : defaultScriptOption;
      scripts[scrKey].s[optId] = {
        ...defOpt,
        t: value,
      };
      return {
        scripts,
        errors,
      };
    });
  };
  onAddNewScriptOption = scrKey => {
    this.setState(prevState => {
      const scripts = _.cloneDeep(prevState.scripts);
      scripts[scrKey].s.push(defaultScriptOption);
      return { scripts };
    });
  };
  deleteScriptOption = (scrKey, optId) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = _.cloneDeep(prevState.scripts);
      scripts[scrKey].s = _.filter(scripts[scrKey].s, (opt, id) => id !== optId);
      keysInScripts.forEach(errorKey => {
        if (errors[errorKey] && errors[errorKey][scrKey]) {
          errors[errorKey][scrKey].splice(optId, 1);
        }
      });
      return {
        scripts,
        errors,
      };
    });
  };
  onChangeScriptOptionValue = (scrKey, optId, value) => {
    this.setState(prevState => {
      const errors = _.cloneDeep(prevState.errors);
      const scripts = _.cloneDeep(prevState.scripts);
      if (!_.get(scripts, `[${scrKey}].s[${optId}].s}`)) {
        if (value) {
          const hasError =
            prevState.errors[errorKeys[5]] &&
            prevState.errors[errorKeys[5]][scrKey] &&
            prevState.errors[errorKeys[5]][scrKey][optId];
          if (hasError) {
            delete errors[errorKeys[5]][scrKey][optId];
          }
        }
      }
      scripts[scrKey].s[optId] = {
        ...scripts[scrKey].s[optId],
        s: value,
      };
      return {
        scripts,
        errors,
      };
    });
  };
  validate = () => {
    const {
      streamTDS: { flow, title },
      scripts,
    } = this.state;
    const errors = {};
    if (!title) {
      errors[errorKeys[0]] = <FMessage id="flow.errors.no-title" />;
    }
    if (!flow) {
      errors[errorKeys[1]] = 1;
    }
    _.each(scripts, (script, key) => {
      if (!script.r) {
        if (!errors[errorKeys[3]]) {
          errors[errorKeys[3]] = [];
        }
        errors[errorKeys[3]][key] = 1;
      }
      if (!script.t) {
        if (!errors[errorKeys[2]]) {
          errors[errorKeys[2]] = [];
        }
        errors[errorKeys[2]][key] = 1;
      }
      // ====== ВАЛИДАЦИЯ ОПЦИЙ ======
      if (script.s.length) {
        _.each(script.s, (option, optInd) => {
          // ====== ТИП ОПЦИИ ======
          if (!option.t) {
            if (!errors[errorKeys[4]]) {
              errors[errorKeys[4]] = [];
            }
            if (!errors[errorKeys[4]][key]) {
              errors[errorKeys[4]][key] = [];
            }
            errors[errorKeys[4]][key][optInd] = 1;
          }
          // ====== ЗНАЧЕНИЕ ОПЦИИ ======
          const isMulti = _.isArray(option.s);
          if (isMulti) {
            if (!option.s.length) {
              if (!errors[errorKeys[5]]) {
                errors[errorKeys[5]] = [];
              }
              if (!errors[errorKeys[5]][key]) {
                errors[errorKeys[5]][key] = [];
              }
              errors[errorKeys[5]][key][optInd] = 1;
            }
          } else {
            if (!option.s) {
              if (!errors[errorKeys[5]]) {
                errors[errorKeys[5]] = [];
              }
              if (!errors[errorKeys[5]][key]) {
                errors[errorKeys[5]][key] = [];
              }
              errors[errorKeys[5]][key][optInd] = 1;
            }
          }
        });
      }
    });
    return errors;
  };
  handleSubmit = e => {
    e.preventDefault();
    const { streamTDS, scripts } = this.state;
    const errors = this.validate();
    this.setState(
      () => ({
        errors,
      }),
      () => {
        const types = Object.keys(errors);
        const scrollKey = this.needScroll(types, errors);
        scrollToError(this._alertRefs, scrollKey);
        if (!types.length) {
          const { id, title, flow } = streamTDS;
          const data = {
            title,
            flow,
            scripts: JSON.stringify(scripts),
          };
          if (id) {
            this.props.onSubmit(id, data);
          } else {
            this.props.onSubmit(data);
          }
        }
      },
    );
  };
  handleSubAccountChange = subAccount => {
    this.setState(() => ({ subAccount }));
  };
  getComputedLink = (link = '', delimiter = '/') => {
    const { subAccount } = this.state;
    if (subAccount) {
      link += `${delimiter}${subAccount}`;
    }
    return link;
  };
  getLink = () => {
    const { link } = this.state.streamTDS;
    if (link && link.host && link.link) {
      return `${link.host}/${link.link}`;
    }
    return '';
  };
  setFlowInfo = value => {
    this.setState(prevState => {
      return {
        ...prevState,
        flowsInfo: [...prevState.flowsInfo, value],
      };
    });
  };
  render() {
    const { streamTDS } = this.state;
    const { flow, title } = streamTDS;
    const { profile } = this.props;
    const isUserBlocked = profile && profile.banned;
    const isEdit = !!streamTDS.id;
    const streamLink = this.getLink();
    const data = { ...this.props, ...this.state, flow, title, isUserBlocked, isEdit, streamLink };
    return (
      <StreamTDSFormView
        data={data}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        onSelectChange={this.onSelectChange}
        getFlowsInfo={this.getFlowsInfo}
        handleSubAccountChange={this.handleSubAccountChange}
        getComputedLink={this.getComputedLink}
        _alertRefs={this._alertRefs}
        saveRef={this.saveRef}
        setFlowInfo={this.setFlowInfo}
        getOffersInfo={this.getOffersInfo}
        handleScriptTitleChange={this.handleScriptTitleChange}
        onSelectScriptDefaultStreamChange={this.onSelectScriptDefaultStreamChange}
        onRemoveScript={this.onRemoveScript}
        onAddScript={this.onAddScript}
        onSelectScriptOptionType={this.onSelectScriptOptionType}
        onAddNewScriptOption={this.onAddNewScriptOption}
        deleteScriptOption={this.deleteScriptOption}
        onChangeScriptOptionValue={this.onChangeScriptOptionValue}
      />
    );
  }
}

const mapStateToProps = ({ streams, webmaster }) => ({
  offers: streams.settings.offers,
  settingsTDS: streams.settings.tds,
  settings: streams.settings,
  defaultStreams: _.filter(streams.streams, stream => stream.flow === 'stream'),
  profile: webmaster.profile,
});

const mapDispatchToProps = dispatch => ({
  resetStream: () => dispatch(resetStream()),
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StreamTDSForm));
